module.exports = __webpack_public_path__ + "static/media/solar-charge-controller.bc7f117d.jpg";